import config from '@creditflowresearch/config';

const SUPPORT_EMAIL = (
  <a href={ `mailto:${ config.supportEmail }` }>{ config.supportEmail }</a>
);
const NEW_ISSUE_EMAIL = (
  <a href={ `mailto:${ config.newissueEmail }` }>{ config.newissueEmail }</a>
);

export default [
  {
    hash: 'whatIsFinsight',
    question: 'What is CreditFlow?',
    answer: (
      <>
        <p>
          CreditFlow is a primary and secondary fixed income data and analysis platform covering global
          Asset-Backed Securities, Investment Grade and High Yield Bonds.
        </p>
        <br />
        <p>
          It enables broker-dealers, institutional investors,
          corporate issuers and other capital market stakeholders to:
        </p>
        <br />
        <ul>
          <li>
            View real-time new issue announcements through pricing by sector,
            sub-sector, industry, sub-industry, parent, issuer and transaction
          </li>
          <li>
            View broker-dealer and rating agency league tables
          </li>
          <li>
            Access bespoke primary and secondary monitors, including our award-winning BWIC & inventory monitor,
            bond screener, loan-level data and 15G pipeline alerts filed on EDGAR.
          </li>
          <li>Leverage rich and actionable commentary, custom reports and more from industry recognized analysts.</li>
          <li>
            Analyze price progression, related deal details, and demand with verified real-time coverage.
          </li>
          <li>
            Maintain a pulse on market activity across credit products and regions with customizable email alerts.
          </li>
        </ul>
      </>
    ),
  },
  {
    hash: 'whereDoesFinsightSourceMarketData',
    question: 'Where does CreditFlow source its market data?',
    answer: (
      <>
        <p>
          CreditFlow aggregates market data from numerous credible sources including broker-dealers,
          institutional investors, industry experts, rating agencies and government agencies.
        </p>
        <br />
        <p>
          <i>
            Interested in becoming a Finsight.com market data contributor? { ' ' }
            Email { NEW_ISSUE_EMAIL } for more information.
          </i>
        </p>
      </>
    ),
  },
  {
    hash: 'canIExportFinsightMarketDataToExcel',
    question: 'Can I export CreditFlow data sets?',
    answer: (
      <>
        <p>
          Yes, CreditFlow offers export to Excel for US ABS data directly through the platform.
          This feature is part of a separate pricing plan.
        </p>
        <br />
        <ul>
          <li>XLS exports of League Tables on Sector, Parent and Issuer Profiles</li>
          <li>CSV and XML files of US ABS Loan-Level Data (ABS-EE)</li>
        </ul>
        <br />
        <p>CreditFlow professional plans include clean exports of everything on Premium, plus:</p>
        <br />
        <ul>
          <li>XLS exports of US ABS BWICs & Inventories</li>
          <li>XLS exports of Stats</li>
          <li>XLS exports of +5 years of historical US IG and HY deal details</li>
        </ul>
        <br />
        <p>For an additional cost, CreditFlow also offers:</p>
        <br />
        <ul>
          <li>
            A comprehensive API covering our US new issue data, deal flow and commentary coverage across
            asset backed securities, investment grade and high yield bond markets.
          </li>
          <li>XLS exports of our entire Bond Screener library.</li>
        </ul>
        <br />
        <p>
          <i>
            Want to learn about Bond Screener Export and/or API pricing?
            Email { SUPPORT_EMAIL }{ ' ' } for more information.
          </i>
        </p>
      </>
    ),
  },
  {
    hash: 'doYouOfferEnterprisePlans',
    question: 'Do you offer enterprise plans and partnerships for access to CreditFlow?',
    answer: (
      <p>
        Yes. For more information about CreditFlow’s Enterprise plans and Media Partner Program,
        speak to our global sales & support desk
        at { SUPPORT_EMAIL }{ ' ' } for a custom quote.
      </p>
    ),
  },
  {
    hash: 'canIPayWithCreditCard',
    question: 'Can I pay for CreditFlow with a credit card?',
    answer: (
      <p>Yes. Note that invoices processed via credit card are subject to a 3% additional fee.</p>
    ),
  },
  {
    hash: 'howShouldIAttributeCreditFlowMarket',
    question: 'How should I attribute CreditFlow market data in news or a digital publication?',
    answer: (
      <>
        <p>
          When referencing data sourced from CreditFlow, please follow these guidelines and note that
          the correct name of our market data platform is CreditFlow, under the parent company
          Finsight Group, Inc. commonly referred to as FINSIGHT.
        </p>
        <br />
        <ul>
          <li>“According to CreditFlow”</li>
          <li>“According to CreditFlow market data”</li>
        </ul>
        <br />
        <p>
          When quoting CreditFlow data, deal flow or commentary, language and data must be used verbatim
          as they appear on creditflowresearch.com. To reproduce or redistribute CreditFlow materials in their entirety,
          please submit your request to { NEW_ISSUE_EMAIL }.
        </p>
      </>
    ),
  },
  {
    hash: 'howDoIManageMyCreditFlowAlerts',
    question: 'How do I manage my CreditFlow email alerts? ',
    answer: (
      <>
        <p>CreditFlow email alerts are currently available for Professional subscriptions.</p>
        <br />
        <p>
          To manage your email alerts, log into your CreditFlow account, click your initials in the top right corner
          of the website toolbar and select “Email Subscriptions”. From here, you’ll be able to customize,
          enable and disable your CreditFlow email alerts to your preference.
        </p>
      </>
    ),
  },
];
